export default {
    PUT_MY_CHAT: (state, data) => {
        if(data.text?.length > 0){
            state.myChatList.push(data)
        }
    },
    REMOVE_MY_CHAT: (state, data) => {
        if(state.myChatList?.length < 1) return;
        state.myChatList = state.myChatList.filter(c => c.myChatIdx !== data.myChatIdx);
    },
    CLEAR_MY_CHAT: (state, data) => {
        if(state.myChatList?.length < 1) return
        state.myChatList = [];
    },
    TOGGLE_CHAT_NOTIFICATION: (state) => {
        state.chatNotification = !state.chatNotification;
    },
    TOGGLE_SYSTEM_MESSAGE: (state, data) => {
        state.systemMessage = data;
    },
    SET_WHISPER_TYPE: (state, data) => {
        state.whisperType = data;
    },
    SET_WHISPER_TARGET: (state, userId) => {
        if(typeof(userId) === 'object') {
            userId = userId.userId
        }
        state.whisperTarget = userId;
    },
    ADD_UNREAD_CHAT: (state) => {
        state.unReadChatLength++;
    },
    RESET_UNREAD_CHAT: (state) => {
        state.unReadChatLength = 0;
    }
}
